import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import ThankYouPage from "@/pages/ThankYouPage";
import { captureParams } from "@/lib/tracking";

function App() {
  useEffect(() => {
    captureParams();
  }, []);
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/thank-you" element={<ThankYouPage />} />
        <Route path="*" element={<Landing />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
